<template>
  <hr class="border-grey-divider-subdued mt-24 mb-16" />
  <p class="text-small text-grey-text-subdued mb-0">
    By accepting this invitation, you acknowledge and agree that participation in the Trusted Sitter Program requires enrollment
    in Sittercity's
    <a
      href="https://support.sittercity.com/hc/en-us/articles/56944661980315-What-is-Continuous-Criminal-Monitoring?utm_medium=help-center&utm_source=tcp-unbounce&utm_campaign=&utm_content=continuous-criminal-monitoring&utm_term="
      class="text-grey-text-subdued underline primary-focus"
      target="_blank"
      rel="noopener noreferrer"
      >Continuous Criminal Monitoring</a
    >
    program as a condition of receiving and maintaining Trusted Sitter status.
  </p>
</template>

<script setup lang="ts">
defineOptions({ name: 'TrustedCaregiverCcmAcknowledgment' });
</script>
